import { useMutation } from "@apollo/client";

import {
  DeleteDeviceTemplateMutation,
  DeleteDeviceTemplateMutationVariables,
} from "../../../../../API";
import { DELETE_DEVICE_TEMPLATE } from "../../../../../common/operations/mutations";
import { successNotification } from "../../../../../common/variables/notification";
import { handleApolloError } from "../../../../../common/utils/handleApolloError";

export const useDeleteDeviceTemplate = () => {
  const [saveDevicesTemplate, { data, loading }] = useMutation<
    DeleteDeviceTemplateMutation,
    DeleteDeviceTemplateMutationVariables
  >(DELETE_DEVICE_TEMPLATE);

  const deleteDeviceTemplate = async (id: string) => {
    return await saveDevicesTemplate({
      variables: {
        id,
      },
      onCompleted: response => {
        if (response.deleteDeviceTemplate) {
          successNotification();
        }
      },
      onError: handleApolloError,
      update(cache) {
        const normalizedId = cache.identify({
          id,
          __typename: "DevicesTemplate",
        });

        cache.evict({ id: normalizedId });

        cache.gc();
      },
    });
  };

  return { deleteDeviceTemplate, data, loading };
};
